import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import ExtrasOrder from './ExtrasOrder';
import { useWindowSize } from 'react-use';
import { parseTitle } from '../pages/mealExchangeStep/helpers/mealExchangeHelpers';

const SideOrders = ({
  activeDay,
  amountSideOrder,
  decrease,
  hideTitle,
  increase,
  label,
  onClick,
  removeCb,
  selected,
  sideOrders,
}) => {
  const [swiper, setSwiper] = useState(null);
  const [isBeginningSlide, setIsBeginningSlide] = useState(true);
  const [isEndSlide, setIsEndSlide] = useState(false);
  const { width } = useWindowSize();

  const goNextSlide = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrevSlide = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  const hideArrowButtons = () => {
    return (
      (sideOrders.length === 2 && width < 992) ||
      (sideOrders.length === 3 && width < 1350) ||
      sideOrders.length > 3
    );
  };

  return (
    <>
      {!hideTitle && (
        <div className="display-flex align-items-center">
          <div className=" hidden-up-sm">
            <h3 className="h300 display-flex align-items-center spacer-right-8">
              Dodatki
              {label && (
                <span className="body-xl display-inline-block spacer-left-4">
                  ({label})
                </span>
              )}
            </h3>
          </div>

          <h3 className="h300 spacer-right-8 hidden-down-sm">
            Dodatki na {parseTitle(activeDay)}
          </h3>
          {!!label && (
            <div className="steps-page__label hidden-down-sm">{label}</div>
          )}
        </div>
      )}
      <div className="position-rel">
        {!isBeginningSlide && hideArrowButtons() && (
          <>
            <Button
              colorBlank
              containerClass="color-primary steps-page__slider-button steps-page__slider-button--left"
              label={<FontAwesomeIcon icon={faArrowLeft} />}
              onClick={goPrevSlide}
            />
            <div className="steps-page__slider-overlay steps-page__slider-overlay--left" />
          </>
        )}

        <Swiper
          breakpoints={{
            0: {
              slidesPerView: 'auto',
              spaceBetween: 16,
            },
          }}
          className="steps-page__list steps-page__list--small-margin-top overflow-inherit"
          longSwipesRatio={0.2}
          onSlideChange={e => {
            setIsBeginningSlide(e.isBeginning);
            setIsEndSlide(e.isEnd);
          }}
          onSwiper={setSwiper}
          threshold={20}
        >
          {sideOrders.map(sideOrder => {
            let {
              amount,
              defaultPrice,
              description,
              imageUrl,
              maxQuantity,
              minQuantity,
              name,
              possibleSideOrderId,
            } = sideOrder || {};

            if (amountSideOrder && amountSideOrder(possibleSideOrderId)) {
              amount = amountSideOrder(possibleSideOrderId);
            }

            return (
              <SwiperSlide
                className="height-auto width-auto"
                key={possibleSideOrderId}
              >
                <ExtrasOrder
                  amount={amount}
                  decrease={() => {
                    if (minQuantity) {
                      minQuantity === amount
                        ? removeCb(sideOrder)
                        : decrease(sideOrder);
                    } else {
                      amount === 1 ? removeCb(sideOrder) : decrease(sideOrder);
                    }
                  }}
                  description={description}
                  disableIncrease={maxQuantity === amount}
                  image={imageUrl}
                  increase={() => increase(sideOrder)}
                  name={name}
                  onClick={() => onClick(sideOrder)}
                  price={defaultPrice}
                  removeCb={() => removeCb(sideOrder)}
                  selected={selected ? selected(possibleSideOrderId) : !!amount}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>

        {!isEndSlide && hideArrowButtons() && (
          <>
            <Button
              colorBlank
              containerClass="color-primary steps-page__slider-button steps-page__slider-button--right"
              icon={<FontAwesomeIcon icon={faArrowRight} />}
              onClick={goNextSlide}
            />
            <div className="steps-page__slider-overlay steps-page__slider-overlay--right" />
          </>
        )}
      </div>
    </>
  );
};

SideOrders.propTypes = {
  amountSideOrder: PropTypes.func,
  decrease: PropTypes.func.isRequired,
  hideTitle: PropTypes.bool,
  increase: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  removeCb: PropTypes.func,
  selected: PropTypes.func,
  sideOrders: PropTypes.array.isRequired,
};

export default SideOrders;
